import { MitigateTimeSheetRecords } from "data/mitigateTimeSheet";
import React from "react";
import { ProgressBar } from 'react-bootstrap';
import styles from './Mitigate.module.scss'


const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct','Nov','Dec'];
const year = new Date().getFullYear();
const records = MitigateTimeSheetRecords;

const getMonth = (dateString: string) => {
    return parseInt(dateString.split("/")[1]) - 1;
}



export default function Mitigate() {
  const currentDate = new Date();

  const getBarStyle = (starDate: string, endDate: string, color: string) => {
    let sdArray = starDate.split("/");
    let edArray = endDate.split("/");
    let startDay = parseInt(sdArray[0]);
    const sDate = new Date(`${sdArray[1]}/${sdArray[0]}/${sdArray[2]}`);
    const eDate = new Date(`${edArray[1]}/${edArray[0]}/${edArray[2]}`);
    /* @ts-ignore */
    const diffTime = Math.abs(eDate - sDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    let barWidth = ((diffDays / 30)* 100) + "%";
    let barLeft = ( startDay/30) * 100 + "%";
    let barStyles = {
      background: color,
      width: barWidth,
      left: barLeft,
    } as React.CSSProperties;
    return barStyles;
  };


  return (
    <div>
      <h2 className="fw-300">FY24 Risk Roadmap</h2>
      <div className={styles.mitigateTable}>
        <table className={styles.timeTable}>
          <thead>
            <tr>
              <th></th>
              {months.map((month: string, i: number) => (
                <th key={i} className="text-uppercase text-center">
                  {month} {year}
                  {/* Marker */}
                  {currentDate.getMonth() === i && (
                    <div
                      style={{
                        left: (currentDate.getDate() / 30) * 100 + "%",
                      }}
                      className={styles.marker}
                    ></div>
                  )}
                </th>
              ))}
            </tr>
          </thead>

          {records.map((record: any, i: number) => (
            <tbody key={i}>
              <tr>
                <td>
                  <div className="d-flex">
                    <span
                      style={{ background: record.color }}
                      className={styles.appIcon}
                    >
                      <i className={"text-7s " + record.icon}></i>
                    </span>

                    <div className="ml-3">
                      <h6 className="fw-300 text-gray-400">
                        {record.fly}
                        <small className="fw-400 ml-2 text-white">
                          {record.title}
                        </small>
                      </h6>
                      <ProgressBar now={record.progress} />
                    </div>
                  </div>
                </td>
                {months.map((month: string, mi: number) => (
                  <td key={mi}>
                    {mi === getMonth(record.taskStarDate) && (
                      <div
                        style={getBarStyle(
                          record.taskStarDate,
                          record.taskEndDate,
                          record.color
                        )}
                        className={styles.taskBar}
                      ></div>
                    )}

                    {/* Marker */}
                    {currentDate.getMonth() === mi && (
                      <div
                        style={{
                          left: (currentDate.getDate() / 30) * 100 + "%",
                        }}
                        className={styles.marker}
                      ></div>
                    )}
                  </td>
                ))}
              </tr>

              {record.data.map((taskData: any, di: any) => (
                <tr key={di}>
                  <td>
                    <div className="d-flex pl-4 ml-2 justify-content-between">
                      <div className="d-inline-flex">
                        <span
                          style={{
                            background:
                              taskData.status === "New" ? "#06AED4" : "#12B76A",
                          }}
                          className={styles.appIcon}
                        >
                          {taskData.status === "New" ? (
                            <i className="icon-bookmark text-7s"></i>
                          ) : (
                            <i className="icon-check text-7s"></i>
                          )}
                        </span>

                        <div className="ml-3">
                          <h6 className="fw-300 text-gray-400">
                            <span
                              className={
                                taskData.status === "New" ? "" : "text-strike"
                              }
                            >
                              {taskData.fly}
                            </span>
                            <small className="fw-400 ml-2 text-white">
                              {taskData.title}
                            </small>
                          </h6>
                        </div>
                      </div>

                      <div className="d-inline-flex">
                        {taskData.status === "New" ? (
                          <span className={styles.statusNew}>New</span>
                        ) : (
                          <span className={styles.status}>Done</span>
                        )}
                        <img
                          src={taskData.user.imageUrl}
                          alt="user"
                          className={styles.avatar}
                        />
                      </div>
                    </div>
                  </td>
                  {months.map((month: string, mi: number) => (
                    <td key={mi}>
                      {mi === getMonth(taskData.taskStarDate) && (
                        <div
                          style={getBarStyle(
                            taskData.taskStarDate,
                            taskData.taskEndDate,
                            record.color
                          )}
                          className={styles.taskBar}
                        >
                          <i className="icon-link"></i>
                        </div>
                      )}
                      {/* Marker */}
                      {currentDate.getMonth() === mi && (
                        <div
                          style={{
                            left: (currentDate.getDate() / 30) * 100 + "%",
                          }}
                          className={styles.marker}
                        ></div>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          ))}
        </table>
      </div>
    </div>
  );
}
